import React from 'react';
import { injectIntl } from 'react-intl';
import { merge, isEqual } from 'lodash';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';
import { withRouter } from 'react-router';
import BarChart from './../Charts/BarChart/BarChart.jsx';
import api from './NewsVolumeChart.api';
import LineChart from './../../reusable/Charts/LineChart/LineChart.jsx';
import { PESTLE_ORDER } from './../../constants';
import commonActions from '../../api/Common.actions';
import reduxStore from '../../reduxStore';

class NewsVolumeChart extends React.Component {
    static defaultProps = {
        backRoute: null
    }

    constructor(props) {
        super(props);

        this.openArticlesOverlay = this.openArticlesOverlay.bind(this);

        this.initialChartData = {
            config: {
                bindto:  '#dashboard-pestle-risk-chart',
                data:    {
                    rows:    [],
                    order:   null,
                    onclick: this.openArticlesOverlay,
                    selection: {
                        enabled: true
                    },
                },
                tooltip: {
                    grouped: false
                },
                padding: {
                    bottom: 60,
                    right: 20
                },
                grid:    {y: {show: true}},
                axis:    {
                    x: {
                        tick: {
                            culling: false,
                            rotate:  -45
                        }
                    },
                    y: {
                        tick: {
                            values: [0, 20, 40, 60, 80, 100],
                            count:  6,
                            format: (value) => value + '%'
                        }
                    }
                }
            }
        };

        this.user = reduxStore.getState().user;

        this.state = {
            chartData: this.initialChartData,
            spinner: true,
            articleListingURL: null,
            articleListingCountURL: null,
            articleListingParams: null,
            riskAngle: null,
            isBarChartVisible: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'bar' || !this.user.appSettings.lineChartEnabled,
            isLineChartVisible: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'line' && this.user.appSettings.lineChartEnabled
        };

        this.loadDashboard = this.loadDashboard.bind(this);
        this.toggleChartView = this.toggleChartView.bind(this);
    }

    openArticlesOverlay(data) {
        let day = this.state.chartData.days[data.index],
            //TODO use day not unixDay timestamp
            unixDay = utils.convertDaysToMilliseconds(day),
            riskAngle = data.name.toLowerCase();

        let catFilter = utils.buildDashboardFilter(this.props.entities, this.props.risk, this.props.pestle, this.props.days, this.props.language);
        catFilter.day = day;

        const backRoute = this.props.backRoute ? "?backRoute=" + this.props.backRoute : "";
        this.props.router.push(`/news/${riskAngle}/${unixDay}/${JSON.stringify(catFilter)}${backRoute}`);
    }

    componentWillMount() {
        this.loadDashboard(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.entities, nextProps.entities) ||
            !isEqual(this.props.language, nextProps.language) ||
            !isEqual(this.props.risk, nextProps.risk)) {
            this.loadDashboard(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadDashboard(days, entities, pestle, risk, language) {
        this.setState({chartData: this.initialChartData, spinner:true});
        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        api.getAndParsePestleRiskData(catFilter)
            .then((chartData) => {
                let completeChartData = merge({
                    config: {
                        tooltip: {
                            format: {
                                value: (value, ratio, id, index) => {

                                    // Display the number of articles calculated from the original chart data
                                    let columnIndex = PESTLE_ORDER.indexOf(id.toLowerCase());

                                    let numberOfArticles = Math.round(
                                        chartData.rowTotals[index + 1] *
                                        (chartData.originalChartData[index + 1][columnIndex] / 100)
                                    );

                                    return this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.'+id.toLowerCase()}) + ' | ' +
                                        numberOfArticles + ' ' +
                                        this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.articles'});
                                }
                            }
                        }
                    }
                }, this.state.chartData, chartData);

                this.setState({
                    chartData: completeChartData,
                    spinner:false
                });

            })
            .catch((error) => {
                utils.logError(error, 'DashboardPestleRiskChart.componentWillMount():');
                this.setState({spinner:false});
                xhr.handleAllErrors(error);
            });
    }

    toggleChartView() {
        let prefs = this.user.preferences.dashboard;
        let updatedPrefs = Object.assign(prefs, {
            newsVolumePodGraphStyle: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'bar' ? 'line' : 'bar'
        });
        commonActions.updateDashboardPrefs({...updatedPrefs});
        this.setState({
            isBarChartVisible:  !this.state.isBarChartVisible,
            isLineChartVisible: !this.state.isLineChartVisible
        })
    }

    render() {

            return (
                <div className="news-volume-chart">
                    <div className="graph-title">
                        {this.props.podTitle}

                        {
                            this.user.appSettings.lineChartEnabled ?
                                <span>
                                    <span className='toggle-text'>
                                        Switch Graph View
                                    </span> <span className='la-Update toggle-icon' onClick={this.toggleChartView} />
                                </span>
                                :
                                null
                        }

                    </div>
                    <div className="graph-container">

                        {
                            this.state.isLineChartVisible ?
                                <div>
                                    {this.state.spinner ? <div className="temporary-loading-spinner" /> : null }
                                    <LineChart days={this.props.days}
                                               category={this.props.category}
                                               entities={this.props.entities}
                                               pestle={this.props.pestle}
                                               risk={this.props.risk}
                                               language={this.props.language}
                                               openArticlesOverlay={this.openArticlesOverlay}
                                    />
                                </div>
                                :
                                null
                        }

                        {
                            this.state.isBarChartVisible ?
                                <div>
                                    {this.state.spinner ? <div className="temporary-loading-spinner" /> : null }
                                    <BarChart config={this.state.chartData.config} />
                                </div>
                                :
                                null
                        }

                    </div>

                </div>
            )
    }

}

export default withRouter(injectIntl(NewsVolumeChart));


// WEBPACK FOOTER //
// ./src/scripts/reusable/NewsVolumeChartPod/NewsVolumeChart.jsx